import { ErrorUnexpectedResult } from '@1hive/connect-core';
export function parseAgreement(result) {
    var _a;
    const agreement = (_a = result.data) === null || _a === void 0 ? void 0 : _a.agreement;
    if (!agreement) {
        throw new ErrorUnexpectedResult('Unable to parse agreement.');
    }
    return {
        id: agreement.id,
        dao: agreement.dao,
        stakingFactory: agreement.stakingFactory,
        currentVersionId: agreement.currentVersion.id,
    };
}
